import script from "./teaserBox.vue?vue&type=script&setup=true&lang=js"
export * from "./teaserBox.vue?vue&type=script&setup=true&lang=js"

import "./teaserBox.vue?vue&type=style&index=0&id=00dbb91a&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00dbb91a"]])

export default __exports__